var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrainWin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 14,
    viewBox: "0 0 34 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paintLinearRed",
    x1: 17.2208,
    y1: 12.1042,
    x2: 17.1244,
    y2: -0.000989054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C8D1D"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E911E",
    offset: 0.260313
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72AD27",
    offset: 1
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 14L30.177 14C32.1227 14 33.5536 12.1765 33.091 10.2867L31.1326 2.28666C30.8039 0.944217 29.6007 3.84599e-07 28.2186 5.05425e-07L17 1.48619e-06L5.78138 2.46695e-06C4.3993 2.58778e-06 3.19606 0.944219 2.86742 2.28667L0.909023 10.2867C0.446388 12.1765 1.87733 14 3.82298 14L17 14Z",
    fill: "url(#paintLinearRed) rgba(114, 173, 39, 1)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrainWin);
export default __webpack_public_path__ + "static/media/trainWin.15a48c87.svg";
export { ForwardRef as ReactComponent };